const useCalculations = ({ measures, type, defaultLengths }) => {
  const archsNr = (measures.length / 2000) + 1

  const scale = (currentValue, defaultValue) => {
    return currentValue / defaultValue
  }

  const lengthToAdd = (measures.length - defaultLengths[type]) / 1000
  const widthToAdd = (measures.width - 2500) / 1000
  const archsToAdd = lengthToAdd / 2

	return {
    archsNr,
    scale,
    lengthToAdd,
    widthToAdd,
    archsToAdd
	}
}

export default useCalculations